/* Omega collection filter bar. Rendered by snippets/collection-filter-bar.liquid.
   Filters the collection grid in the browser by product tags. Two profiles, picked after products.json loads:
     design  (default)  Style - <Value>, <Colour> - Primary, <Colour> - Secondary. Values from Theme settings.
     fitment (plastics) model:<Model>, year:<YYYY>, brand:<Maker>, make:<Make>. Values straight from the tags.
                        Used when any loaded product carries the tag type:plastic-kit.
   OR inside a group, AND across groups. Secondary needs a primary (design profile).
   Data: /collections/<handle>/products.json (all pages, in parallel), cached in sessionStorage per profile. */
(function () {
  'use strict';

  var root = document.getElementById('OmegaFilterBar');
  var cfgEl = document.querySelector('[data-omega-fb-config]');
  if (!root || !cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var S = cfg.strings || {};
  var CACHE_TTL = 15 * 60 * 1000;
  var FITMENT_TAG = 'type:plastic-kit';

  /* ---------- helpers ---------- */
  function norm(s) { return String(s || '').trim().replace(/\s+/g, ' ').toLowerCase(); }
  function handleize(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function parseLines(t) { return String(t || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function tpl(str, n) { return String(str || '').replace('[count]', n); }
  function countText(n, one, many) { return n === 1 && one ? one : tpl(many, n); }
  function money(cents) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }
  function hash(s) { var h = 0; for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0; return String(h); }
  /* Natural sort: RR125 before RR390 before RR480, "2T" before "4T", case-insensitive. */
  var collator = (function () {
    try { return new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' }); } catch (e) { return null; }
  })();
  function naturalCompare(a, b) {
    if (collator) return collator.compare(a, b);
    return String(a).toLowerCase().localeCompare(String(b).toLowerCase());
  }
  var VALUE_SORTERS = {
    list: null, /* keep the order values were registered in (Theme settings list order) */
    natural: function (a, b) { return naturalCompare(a.name, b.name); },
    alpha: function (a, b) { return naturalCompare(a.name, b.name); },
    numericDesc: function (a, b) { return (parseFloat(b.name) || 0) - (parseFloat(a.name) || 0) || naturalCompare(b.name, a.name); }
  };

  /* ---------- value lists (from Theme settings, design profile only) ---------- */
  function buildList(lines, withHex) {
    return lines.map(function (line) {
      var name = line, hex = '';
      if (withHex) {
        var i = line.indexOf(':');
        if (i > -1) { name = line.slice(0, i).trim(); hex = line.slice(i + 1).trim(); }
      }
      return { name: name, key: norm(name), handle: handleize(name), hex: hex };
    }).filter(function (v) { return v.key; });
  }
  var styleList = buildList(parseLines(cfg.styleValues), false);
  var colourList = buildList(parseLines(cfg.colourValues), true);

  /* ---------- profiles ----------
     A group: key (state + URL param), label, re (tag regex, capture 1 = value), values (fixed list or null = from tags),
     sort (VALUE_SORTERS name), search (type-to-search box), minValues (hide the group below this many values),
     swatch (colour dot on options and chips), requires (group that must have a selection first), chipPrefix.
     Profile flag softOff: unavailable values are greyed but stay clickable, so a customer can reach the empty state. */
  var PROFILES = {
    design: {
      id: 'design',
      groups: [
        { key: 'style', label: S.style || 'Style', re: /^style\s*-\s*(.+)$/i, values: styleList, sort: 'list', search: false, minValues: 1, swatch: false, menuClass: '' },
        { key: 'primary', label: S.primary || 'Primary colour', re: /^(.+?)\s*-\s*primary$/i, values: colourList, sort: 'list', search: false, minValues: 1, swatch: true, menuClass: ' omega-fb__menu--colour' },
        { key: 'secondary', label: S.secondary || 'Secondary colour', re: /^(.+?)\s*-\s*secondary$/i, values: colourList, sort: 'list', search: false, minValues: 1, swatch: true, menuClass: ' omega-fb__menu--colour', requires: 'primary', hint: S.secondaryHint || '', chipPrefix: S.second || '2nd' }
      ],
      count: S.count || '[count] designs', countOne: S.countOne || '1 design', empty: S.empty || 'No designs match those filters.'
    },
    fitment: {
      id: 'fitment',
      groups: [
        { key: 'model', label: S.model || 'Model', re: /^model:\s*(.+)$/i, values: null, sort: 'natural', search: true, minValues: 2, swatch: false, menuClass: ' omega-fb__menu--list' },
        { key: 'year', label: S.year || 'Year', re: /^year:\s*(\d{4})\s*$/i, values: null, sort: 'numericDesc', search: false, minValues: 2, swatch: false, menuClass: ' omega-fb__menu--list' },
        { key: 'brand', label: S.brand || 'Brand', re: /^brand:\s*(.+)$/i, values: null, sort: 'alpha', search: false, minValues: 2, swatch: false, menuClass: ' omega-fb__menu--list' },
        { key: 'make', label: S.make || 'Make', re: /^make:\s*(.+)$/i, values: null, sort: 'alpha', search: false, minValues: 2, swatch: false, menuClass: ' omega-fb__menu--list' }
      ],
      count: S.kitCount || '[count] kits', countOne: S.kitCountOne || '1 kit', empty: S.kitEmpty || 'No kits match those filters.',
      softOff: true
    }
  };
  var ALL_PARAMS = [];
  Object.keys(PROFILES).forEach(function (id) { PROFILES[id].groups.forEach(function (g) { if (ALL_PARAMS.indexOf(g.key) === -1) ALL_PARAMS.push(g.key); }); });

  /* Set once the profile is known (after products.json). */
  var P = null;          /* active profile */
  var GROUPS = [];       /* group keys in display order */
  var GROUP = {};        /* key -> group definition */
  var VALUES = {};       /* key -> ordered value list [{name, key, handle, hex}] */
  var byKey = {}, byHandle = {};

  function registerValue(g, name, hex) {
    var k = norm(name);
    if (!k) return null;
    if (!byKey[g][k]) {
      var v = { name: String(name).trim().replace(/\s+/g, ' '), key: k, handle: handleize(name), hex: hex || '' };
      byKey[g][k] = v;
      byHandle[g][v.handle] = v;
      VALUES[g].push(v);
    }
    return byKey[g][k];
  }
  function useProfile(id) {
    P = PROFILES[id] || PROFILES.design;
    GROUPS = []; GROUP = {}; VALUES = {}; byKey = {}; byHandle = {};
    P.groups.forEach(function (g) {
      GROUPS.push(g.key); GROUP[g.key] = g;
      VALUES[g.key] = []; byKey[g.key] = {}; byHandle[g.key] = {};
      if (g.values) g.values.forEach(function (v) { registerValue(g.key, v.name, v.hex); });
    });
  }
  function detectProfile(rawProducts) {
    for (var i = 0; i < rawProducts.length; i++) {
      var tags = rawProducts[i].tags || [];
      for (var j = 0; j < tags.length; j++) if (norm(tags[j]) === FITMENT_TAG) return 'fitment';
    }
    return 'design';
  }

  /* Tags -> per-group value keys. Fixed-list groups keep only listed values; tag-driven groups register what they see. */
  function classify(tags) {
    var out = { label: null };
    GROUPS.forEach(function (g) { out[g] = []; });
    (tags || []).forEach(function (tag) {
      if (tag.indexOf('_label_') === 0) { out.label = tag.replace('_label_', ''); return; }
      for (var i = 0; i < GROUPS.length; i++) {
        var g = GROUPS[i], def = GROUP[g], m = def.re.exec(tag);
        if (!m) continue;
        var hit = def.values ? byKey[g][norm(m[1])] : registerValue(g, m[1]);
        if (hit && out[g].indexOf(hit.key) === -1) out[g].push(hit.key);
        return;
      }
    });
    return out;
  }
  function sortValues() {
    GROUPS.forEach(function (g) {
      var cmp = VALUE_SORTERS[GROUP[g].sort];
      if (cmp) VALUES[g].sort(cmp);
    });
  }

  /* ---------- state ---------- */
  var state = {};
  var pendingUrl = {};   /* param -> [handles] read from the URL before values are known */
  var products = [];
  var totals = {};
  var native = null;
  var ui = { menus: {}, opened: null, pushedSinceOpen: false };

  function enforceDeps() {
    GROUPS.forEach(function (g) {
      var req = GROUP[g].requires;
      if (req && state[req] && !state[req].length) state[g] = [];
    });
  }

  /* ---------- data ---------- */
  function toCents(v) { var n = Math.round(parseFloat(v) * 100); return isNaN(n) ? 0 : n; }
  function slim(p) {
    var f = classify(p.tags);
    var imgs = p.images || [], vs = p.variants || [];
    var prices = vs.map(function (v) { return toCents(v.price); });
    var compares = vs.filter(function (v) { return v.compare_at_price; }).map(function (v) { return toCents(v.compare_at_price); });
    function im(i) { return i && i.src ? { src: i.src, w: i.width, h: i.height } : null; }
    var out = {
      id: p.id, handle: p.handle, title: p.title, label: f.label,
      image: im(imgs[0]), image2: im(imgs[1]),
      min: prices.length ? Math.min.apply(null, prices) : 0,
      max: prices.length ? Math.max.apply(null, prices) : 0,
      compare: compares.length ? Math.min.apply(null, compares) : 0,
      available: vs.some(function (v) { return v.available; }),
      created: p.created_at || ''
    };
    GROUPS.forEach(function (g) { out[g] = f[g]; });
    return out;
  }
  function cacheKey(profileId) { return 'omegafb:v2:' + profileId + ':' + cfg.handle + ':' + hash(String(cfg.styleValues) + '|' + String(cfg.colourValues)); }
  function readCache() {
    var ids = Object.keys(PROFILES);
    for (var i = 0; i < ids.length; i++) {
      try {
        var raw = sessionStorage.getItem(cacheKey(ids[i]));
        if (!raw) continue;
        var c = JSON.parse(raw);
        if (!c || c.count !== cfg.productsCount || Date.now() - c.t > CACHE_TTL || !Array.isArray(c.products) || !PROFILES[c.profile]) continue;
        return c;
      } catch (e) {}
    }
    return null;
  }
  /* names: display names of tag-driven values, keyed by group then value key (the slim products only carry keys). */
  function writeCache(profileId, list, names) {
    try { sessionStorage.setItem(cacheKey(profileId), JSON.stringify({ t: Date.now(), count: cfg.productsCount, profile: profileId, products: list, names: names })); } catch (e) {}
  }
  function valueNames() {
    var out = {};
    GROUPS.forEach(function (g) {
      if (GROUP[g].values) return;
      out[g] = {};
      VALUES[g].forEach(function (v) { out[g][v.key] = v.name; });
    });
    return out;
  }
  function fetchPage(page) {
    var url = cfg.collectionUrl + '/products.json?limit=' + cfg.perPage + '&page=' + page;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status + ' on ' + url); return r.json(); })
      .then(function (j) { return j.products || []; });
  }
  /* Resolves to { profile, products }. Cached products are already slimmed for their profile; a fresh fetch
     detects the profile from the raw tags first, then slims. Values for tag-driven groups are re-registered
     from the slimmed products in init(), so both paths end up with the same value lists. */
  function load() {
    var cached = readCache();
    if (cached) { useProfile(cached.profile); return Promise.resolve({ profile: cached.profile, products: cached.products, names: cached.names || {} }); }
    var pages = Math.max(1, Math.ceil((cfg.productsCount || 0) / cfg.perPage)), jobs = [];
    for (var p = 1; p <= pages; p++) jobs.push(fetchPage(p));
    return Promise.all(jobs).then(function (lists) {
      var raw = [].concat.apply([], lists);
      var id = detectProfile(raw);
      useProfile(id);
      var all = raw.map(slim);
      var names = valueNames();
      writeCache(id, all, names);
      return { profile: id, products: all, names: names };
    });
  }

  /* ---------- filtering ---------- */
  function matchesGroup(p, g, sel) {
    if (!sel.length) return true;
    var have = p[g] || [];
    for (var i = 0; i < sel.length; i++) if (have.indexOf(sel[i]) > -1) return true;
    return false;
  }
  function matches(p, except) {
    for (var i = 0; i < GROUPS.length; i++) {
      var g = GROUPS[i];
      if (g === except) continue;
      if (!matchesGroup(p, g, state[g])) return false;
    }
    return true;
  }
  function isActive() { return GROUPS.some(function (g) { return state[g] && state[g].length > 0; }); }
  function availableIn(g) {
    var set = {};
    products.forEach(function (p) { if (matches(p, g)) (p[g] || []).forEach(function (k) { set[k] = true; }); });
    return set;
  }
  function currentList() { return products.filter(function (p) { return matches(p, null); }); }
  function sortKey() {
    try { return new URLSearchParams(location.search).get('sort_by') || cfg.sortBy || cfg.defaultSort || ''; } catch (e) { return ''; }
  }
  var SORTERS = {
    'title-ascending': function (a, b) { return a.title.localeCompare(b.title); },
    'title-descending': function (a, b) { return b.title.localeCompare(a.title); },
    'price-ascending': function (a, b) { return a.min - b.min; },
    'price-descending': function (a, b) { return b.min - a.min; },
    'created-ascending': function (a, b) { return a.created < b.created ? -1 : a.created > b.created ? 1 : 0; },
    'created-descending': function (a, b) { return a.created > b.created ? -1 : a.created < b.created ? 1 : 0; }
  };
  function sorted(list) {
    var cmp = SORTERS[sortKey()], out = list.slice();
    if (cmp) out.sort(cmp);
    return out;
  }
  /* Sort options come from the theme's own #SortBy select (kept in the DOM, hidden).
     Skipped: the theme's placeholder (first option, whose value repeats later), and any order the bar
     cannot reproduce from products.json (only title/price/date and the collection's default order can be). */
  function sortOptions(sel) {
    var opts = Array.prototype.slice.call(sel.options), out = [], seen = {};
    var first = opts[0];
    var placeholder = !!first && (norm(first.textContent) === 'sort' || opts.slice(1).some(function (o) { return o.value === first.value; }));
    opts.forEach(function (o, i) {
      if ((i === 0 && placeholder) || seen[o.value]) return;
      if (!SORTERS[o.value] && o.value !== cfg.defaultSort) return;
      seen[o.value] = true;
      out.push({ value: o.value, text: o.textContent.trim() });
    });
    return out;
  }
  function currentSort(opts, sel) {
    var key = sortKey(), hit = null;
    opts.forEach(function (o) { if (!hit && o.value === key) hit = o; });
    if (!hit) opts.forEach(function (o) { if (!hit && o.value === sel.value) hit = o; });
    return hit;
  }
  function setSort(value) {
    var sel = document.getElementById('SortBy');
    if (sel) {
      sel.value = value;
      if (sel.value === value) { sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
    }
    var params;
    try { params = new URLSearchParams(location.search); } catch (e) { return; }
    params.set('sort_by', value);
    params.delete('page');
    location.search = params.toString();
  }

  /* ---------- native grid capture, render, restore ---------- */
  function captureNative() {
    var grid = document.querySelector('#CollectionAjaxContent .grid--uniform');
    if (!grid) return null;
    var first = grid.querySelector('.grid-product');
    var cls = first
      ? Array.prototype.filter.call(first.classList, function (c) { return !/^aos-/.test(c) && !/^eosh-/.test(c) && c !== 'grid-product__has-quick-shop'; }).join(' ')
      : 'grid__item grid-product small--one-half medium-up--one-quarter';
    var img = first ? first.querySelector('.grid-product__image-mask img') : null;
    var pag = document.querySelector('#CollectionAjaxContent .pagination');
    var mine = document.createElement('div');
    mine.className = grid.className + ' omega-fb__results';
    return {
      grid: grid, mine: mine, cardClass: cls,
      rowOf: first && first.getAttribute('data-aos') ? first.getAttribute('data-aos').replace('row-of-', '') : '4',
      sizes: (img && img.getAttribute('sizes')) || '(min-width: 769px) 25vw, 50vw',
      pagination: pag, pagParent: pag ? pag.parentNode : null, pagNext: pag ? pag.nextSibling : null,
      replaced: false
    };
  }

  var hover = root.getAttribute('data-hover-image') === 'true';
  var titleStyle = root.getAttribute('data-title-style') || 'body';
  var saveAmount = root.getAttribute('data-save-amount') === 'true';
  var saveType = root.getAttribute('data-save-type') || 'dollar';

  function onSale(p) { return p.compare > p.min; }
  function imgHTML(im, cls, widths) {
    var sep = im.src.indexOf('?') > -1 ? '&' : '?';
    var ratio = (im.w && im.h) ? im.h / im.w : 0.6;
    var maxW = widths[widths.length - 1];
    var srcset = widths.map(function (w) { return im.src + sep + 'width=' + w + ' ' + w + 'w'; }).join(', ');
    return '<image-element data-aos="image-fade-in" data-aos-offset="150" class="aos-init aos-animate">'
      + '<img src="' + esc(im.src + sep + 'width=' + maxW) + '" srcset="' + esc(srcset) + '" width="' + maxW + '" height="' + Math.round(maxW * ratio) + '" loading="lazy" class="' + cls + '" sizes="' + esc(native.sizes) + '" alt="">'
      + '</image-element>';
  }
  function priceHTML(p) {
    var h = '', sale = onSale(p);
    if (sale) {
      h += '<span class="visually-hidden">' + esc(S.regular) + '</span><span class="grid-product__price--original">' + money(p.compare) + '</span><span class="visually-hidden">' + esc(S.salePrice) + '</span>';
    }
    if (p.min !== p.max) h += String(S.from || '').replace(/\s+$/, '') + ' ' + money(p.min);
    else h += money(p.min);
    if (sale && saveAmount) {
      var saved = saveType === 'dollar' ? money(p.compare - p.min) : Math.round((p.compare - p.min) * 100 / p.compare) + '%';
      h += '<span class="grid-product__price--savings">' + String(S.save || '').replace('[saved_amount]', saved) + '</span>';
    }
    return h;
  }
  function cardHTML(p) {
    var tag = '';
    if (p.label) tag = '<div class="grid-product__tag grid-product__tag--custom">' + esc(p.label) + '</div>';
    else if (!p.available) tag = '<div class="grid-product__tag grid-product__tag--sold-out">' + esc(S.soldOut) + '</div>';
    else if (onSale(p)) tag = '<div class="grid-product__tag grid-product__tag--sale">' + esc(S.sale) + '</div>';
    var ratio = (p.image && p.image.w && p.image.h) ? (p.image.h / p.image.w * 100) : 60;
    var main = '<div class="image-wrap" style="height:0;padding-bottom:' + ratio.toFixed(4) + '%;">' + (p.image ? imgHTML(p.image, 'grid-product__image image-element', [360, 540, 720, 900, 1080]) : '') + '</div>';
    var second = (hover && p.image2) ? '<div class="grid-product__secondary-image small--hide">' + imgHTML(p.image2, 'image-element', [360, 540, 720, 1000]) + '</div>' : '';
    return '<div class="' + native.cardClass + ' aos-init aos-animate" data-aos="row-of-' + native.rowOf + '" data-product-handle="' + esc(p.handle) + '" data-product-id="' + p.id + '">'
      + '<div class="grid-product__content">' + tag
      + '<div class="grid__item-image-wrapper"><div class="grid-product__image-mask">' + main + second + '</div>'
      + '<a href="' + esc(cfg.collectionUrl + '/products/' + p.handle) + '" class="grid-product__link"><div class="grid-product__meta">'
      + '<div class="grid-product__title grid-product__title--' + esc(titleStyle) + '">' + esc(p.title) + '</div>'
      + '<div class="grid-product__price">' + priceHTML(p) + '</div>'
      + '</div></a></div></div></div>';
  }
  /* Filtered results go into a grid of our own, placed before the theme's grid, which is hidden rather than emptied.
     The "Load More & Infinite Scroll" app keeps a reference to the theme's grid and appends further pages into it
     whenever the page is short, so those cards must land out of sight and come back untouched on Clear all. */
  function renderGrid(list) {
    if (!native) return;
    if (!native.replaced) {
      native.replaced = true;
      native.grid.parentNode.insertBefore(native.mine, native.grid);
      native.grid.style.display = 'none';
      if (native.pagination && native.pagination.parentNode) native.pagination.parentNode.removeChild(native.pagination);
    }
    native.mine.innerHTML = list.length
      ? list.map(cardHTML).join('')
      : '<div class="omega-fb__empty">' + esc(P.empty) + ' <button type="button" class="omega-fb__clear" data-fb-action="clear-all">' + esc(S.clearAll) + '</button></div>';
    document.body.classList.add('omega-fb-filtered');
  }
  function restoreGrid() {
    if (!native || !native.replaced) return;
    native.replaced = false;
    if (native.mine.parentNode) native.mine.parentNode.removeChild(native.mine);
    native.mine.innerHTML = '';
    native.grid.style.display = '';
    if (native.pagination && native.pagParent) {
      var ref = (native.pagNext && native.pagNext.parentNode === native.pagParent) ? native.pagNext : null;
      native.pagParent.insertBefore(native.pagination, ref);
    }
    document.body.classList.remove('omega-fb-filtered');
  }

  /* ---------- URL state ---------- */
  /* Runs before products.json is loaded (so the profile and its values are not known yet): keeps the raw handles. */
  function readUrl() {
    var params;
    pendingUrl = {};
    try { params = new URLSearchParams(location.search); } catch (e) { return; }
    ALL_PARAMS.forEach(function (k) {
      var raw = params.get(k);
      if (raw) pendingUrl[k] = raw.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    });
  }
  function urlHasFilters() { return Object.keys(pendingUrl).length > 0; }
  /* Turns the pending handles into state once the profile's values exist. */
  function resolveState() {
    GROUPS.forEach(function (g) {
      state[g] = [];
      (pendingUrl[g] || []).forEach(function (h) {
        var v = byHandle[g][h];
        if (v && state[g].indexOf(v.key) === -1) state[g].push(v.key);
      });
    });
    enforceDeps();
  }
  function writeUrl(push) {
    var params;
    try { params = new URLSearchParams(location.search); } catch (e) { return; }
    GROUPS.forEach(function (g) {
      if (state[g].length) params.set(g, state[g].map(function (k) { return byKey[g][k].handle; }).join(','));
      else params.delete(g);
    });
    if (isActive()) params.delete('page');
    var qs = params.toString().replace(/%2C/gi, ',');
    var url = location.pathname + (qs ? '?' + qs : '') + location.hash;
    if (url === location.pathname + location.search + location.hash) return;
    try { history[push ? 'pushState' : 'replaceState']({ omegaFb: true }, '', url); } catch (e) {}
  }

  /* ---------- bar ---------- */
  function menuHead(title) {
    return el('div', 'omega-fb__sheet-head', '<span>' + esc(title) + '</span><button type="button" class="omega-fb__x omega-fb__x--close" data-fb-action="close" aria-label="Close">&times;</button>');
  }
  function pill(dds, group, btnHTML, menuClass, title) {
    var dd = el('div', 'omega-fb__dd' + (group === 'sort' ? ' omega-fb__dd--sort' : ''));
    dd.setAttribute('data-group', group);
    var btn = el('button', 'omega-fb__btn', btnHTML);
    btn.type = 'button';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-haspopup', 'true');
    var menu = el('div', 'omega-fb__menu' + menuClass);
    menu.hidden = true;
    menu.setAttribute('data-group', group);
    menu.appendChild(menuHead(title));
    var grid = el('div', 'omega-fb__grid');
    menu.appendChild(grid);
    dd.appendChild(btn);
    dd.appendChild(menu);
    dds.appendChild(dd);
    return { dd: dd, btn: btn, menu: menu, grid: grid };
  }
  /* Type-to-search box above a long option list. Hides options that do not contain every typed word. */
  function searchBox(m, label) {
    var wrap = el('div', 'omega-fb__search');
    var input = el('input', 'omega-fb__search-input');
    input.type = 'search';
    input.autocomplete = 'off';
    input.setAttribute('placeholder', String(S.search || 'Search [label]').replace('[label]', String(label).toLowerCase()));
    input.setAttribute('aria-label', input.getAttribute('placeholder'));
    wrap.appendChild(input);
    m.menu.insertBefore(wrap, m.grid);
    m.search = input;
    m.searchEmpty = el('div', 'omega-fb__search-empty', esc(S.searchEmpty || 'No matches'));
    m.searchEmpty.hidden = true;
    m.menu.insertBefore(m.searchEmpty, m.grid.nextSibling);
    function run() {
      var words = norm(input.value).split(' ').filter(Boolean), shown = 0;
      Array.prototype.forEach.call(m.grid.querySelectorAll('.omega-fb__opt'), function (opt) {
        var text = norm(opt.textContent);
        var hide = words.some(function (w) { return text.indexOf(w) === -1; }); /* every typed word must appear */
        opt.classList.toggle('is-hidden', hide);
        if (!hide) shown++;
      });
      m.searchEmpty.hidden = shown > 0;
    }
    input.addEventListener('input', run);
    input.addEventListener('search', run);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    m.runSearch = run;
  }
  function build() {
    root.innerHTML = '';
    var bar = el('div', 'omega-fb__bar');
    bar.appendChild(el('span', 'omega-fb__label', esc(S.filter || 'Filter')));
    var dds = el('div', 'omega-fb__dds');
    GROUPS.forEach(function (g) {
      var def = GROUP[g];
      var vals = VALUES[g].filter(function (v) { return totals[g][v.key] > 0; });
      if (vals.length < def.minValues) return;
      var m = pill(dds, g, esc(def.label) + ' <span class="omega-fb__n" hidden>0</span>', def.menuClass + (P.softOff ? ' omega-fb__menu--soft' : ''), def.label);
      vals.forEach(function (v) {
        var sw = def.swatch ? '<span class="omega-fb__sw" style="background:' + esc(v.hex || '#ddd') + '"></span>' : '';
        m.grid.appendChild(el('label', 'omega-fb__opt', '<input type="checkbox" value="' + esc(v.key) + '">' + sw + '<span>' + esc(v.name) + '</span>'));
      });
      if (def.search) searchBox(m, def.label);
      var foot = el('div', 'omega-fb__foot', '<button type="button" class="omega-fb__link" data-fb-action="clear-group">' + esc(S.clear || 'Clear') + '</button><span class="omega-fb__foot-right"><span class="omega-fb__foot-count"></span><button type="button" class="omega-fb__done" data-fb-action="close">' + esc(S.done || 'Done') + '</button></span>');
      m.menu.appendChild(foot);
      m.n = m.btn.querySelector('.omega-fb__n');
      m.count = foot.querySelector('.omega-fb__foot-count');
      ui.menus[g] = m;
    });
    /* Sort: a pill at the end of the row. The theme's select stays in the DOM (hidden) so its own change handler does the reload. */
    var sortWrap = document.querySelector('#CollectionAjaxContent .collection-filter__sort-container');
    var sortSel = sortWrap ? sortWrap.querySelector('#SortBy') : null;
    if (sortSel) {
      var opts = sortOptions(sortSel), cur = currentSort(opts, sortSel);
      if (opts.length) {
        var sm = pill(dds, 'sort', esc(S.sort || 'Sort') + ' <span class="omega-fb__cur">' + esc(cur ? cur.text : '') + '</span>', ' omega-fb__menu--sort', S.sort || 'Sort');
        opts.forEach(function (o) {
          sm.grid.appendChild(el('label', 'omega-fb__opt', '<input type="radio" name="omega-fb-sort" value="' + esc(o.value) + '"' + (cur && o.value === cur.value ? ' checked' : '') + '><span>' + esc(o.text) + '</span>'));
        });
        ui.menus.sort = sm;
      }
      ui.sort = el('div', 'omega-fb__sort');
      ui.sort.appendChild(sortWrap);
    }
    bar.appendChild(dds);
    var row2 = el('div', 'omega-fb__row2');
    ui.active = el('div', 'omega-fb__active');
    ui.right = el('div', 'omega-fb__right');
    ui.count = el('span', 'omega-fb__count');
    ui.right.appendChild(ui.count);
    row2.appendChild(ui.active);
    row2.appendChild(ui.right);
    bar.appendChild(row2);
    root.appendChild(bar);
    root.setAttribute('data-profile', P.id);
    ui.overlay = el('div', 'omega-fb__overlay');
    root.appendChild(ui.overlay);
    if (ui.sort) root.appendChild(ui.sort);
    document.body.classList.add('omega-fb-on');
    bind();
  }

  function clearAll() { GROUPS.forEach(function (g) { state[g] = []; }); }

  /* On mobile the open sheet and the overlay are moved to <body> while open, so no ancestor (the scrolling pill row
     above all) can clip or pin them. Listeners therefore sit on document and check scope themselves. */
  function openMenu() { var m = ui.opened && ui.menus[ui.opened]; return m ? m.menu : null; }
  function inScope(t) {
    if (!t || !t.closest) return false;
    if (root.contains(t)) return true;
    var menu = openMenu();
    return !!(menu && menu.contains(t));
  }
  function groupOf(t) { var g = t.closest('[data-group]'); return g ? g.getAttribute('data-group') : null; }

  function bind() {
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches || !input.matches('.omega-fb__opt input') || !inScope(input)) return;
      var g = groupOf(input), k = input.value;
      if (g === 'sort') { if (input.checked) setSort(k); return; }
      if (!g || !state[g]) return;
      if (input.checked) { if (state[g].indexOf(k) === -1) state[g].push(k); }
      else state[g] = state[g].filter(function (x) { return x !== k; });
      enforceDeps();
      apply(!ui.pushedSinceOpen);
      ui.pushedSinceOpen = true;
    });
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('.omega-fb__btn');
      if (btn && root.contains(btn)) { if (!btn.disabled) toggle(groupOf(btn)); return; }
      var act = t.closest('[data-fb-action]');
      if (act) {
        var a = act.getAttribute('data-fb-action');
        if (a === 'clear-all') { clearAll(); close(); apply(true); return; } /* bar chips row and the empty-state button in the grid */
        if (!inScope(act)) return;
        if (a === 'close') close();
        else if (a === 'clear-group') {
          var g = groupOf(act);
          if (g && state[g]) { state[g] = []; enforceDeps(); apply(true); }
        } else if (a === 'remove') {
          var g2 = act.getAttribute('data-group'), k = act.getAttribute('data-key');
          if (state[g2]) {
            state[g2] = state[g2].filter(function (x) { return x !== k; });
            enforceDeps();
            apply(true);
          }
        }
        return;
      }
      if (t === ui.overlay) { close(); return; }
      if (ui.opened && !inScope(t)) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('popstate', function () { readUrl(); resolveState(); apply(false); });
  }
  function toggle(g) { if (ui.opened === g) close(); else open(g); }
  function previewBarOffset() {
    /* Shopify's draft preview bar sits on the bottom edge. Only trust its height when it actually looks like a bar. */
    var el = document.getElementById('PBarNextFrameWrapper');
    if (!el) return 0;
    var r = el.getBoundingClientRect();
    if (!(r.height > 0 && r.height <= 160) || Math.abs(r.bottom - window.innerHeight) > 8) return 0;
    return Math.round(r.height);
  }
  function open(g) {
    close();
    var m = ui.menus[g];
    if (!m) return;
    m.dd.classList.add('is-open');
    m.btn.setAttribute('aria-expanded', 'true');
    ui.opened = g;
    ui.pushedSinceOpen = false;
    if (isMobile()) {
      document.body.appendChild(ui.overlay);
      document.body.appendChild(m.menu);
      m.menu.classList.add('omega-fb__menu--sheet');
      var off = previewBarOffset();
      m.menu.style.bottom = off ? off + 'px' : '';
      ui.overlay.classList.add('is-on');
      document.body.classList.add('omega-fb-lock');
    }
    m.menu.hidden = false;
    if (m.search && !isMobile()) { try { m.search.focus({ preventScroll: true }); } catch (e) {} }
  }
  function close() {
    if (!ui.opened) return;
    var m = ui.menus[ui.opened];
    m.dd.classList.remove('is-open');
    m.menu.hidden = true;
    m.menu.style.bottom = '';
    m.menu.classList.remove('omega-fb__menu--sheet');
    if (m.menu.parentNode !== m.dd) m.dd.appendChild(m.menu);
    m.btn.setAttribute('aria-expanded', 'false');
    if (m.search) { m.search.value = ''; m.runSearch(); }
    ui.opened = null;
    ui.overlay.classList.remove('is-on');
    if (ui.overlay.parentNode !== root) root.appendChild(ui.overlay);
    document.body.classList.remove('omega-fb-lock');
  }

  function apply(push) {
    var active = isActive();
    var list = active ? sorted(currentList()) : null;
    if (active) renderGrid(list); else restoreGrid();
    update(list ? list.length : products.length);
    writeUrl(push);
  }
  function update(n) {
    GROUPS.forEach(function (g) {
      var m = ui.menus[g], def = GROUP[g];
      if (!m) return;
      var avail = availableIn(g);
      Array.prototype.forEach.call(m.grid.querySelectorAll('input'), function (input) {
        var k = input.value, on = state[g].indexOf(k) > -1, off = !on && !avail[k];
        input.checked = on;
        input.disabled = off && !P.softOff;
        input.closest('.omega-fb__opt').classList.toggle('is-off', off);
      });
      var c = state[g].length;
      m.n.textContent = c;
      m.n.hidden = !c;
      m.count.textContent = countText(n, P.countOne, P.count);
      if (def.requires) {
        var locked = !(state[def.requires] && state[def.requires].length);
        m.btn.disabled = locked;
        m.btn.title = locked ? (def.hint || '') : '';
        if (locked && ui.opened === g) close();
      }
    });
    var chips = '';
    GROUPS.forEach(function (g) {
      var def = GROUP[g];
      state[g].forEach(function (k) {
        var v = byKey[g][k];
        chips += '<span class="omega-fb__chip">'
          + (def.swatch ? '<span class="omega-fb__sw" style="background:' + esc(v.hex || '#ddd') + '"></span>' : '')
          + (def.chipPrefix ? '<small>' + esc(def.chipPrefix) + '</small>' : '')
          + esc(v.name)
          + '<button type="button" class="omega-fb__x" data-fb-action="remove" data-group="' + g + '" data-key="' + esc(k) + '" aria-label="Remove ' + esc(v.name) + '">&times;</button></span>';
      });
    });
    if (chips) chips += '<button type="button" class="omega-fb__clear" data-fb-action="clear-all">' + esc(S.clearAll) + '</button>';
    ui.active.innerHTML = chips;
    ui.count.textContent = countText(n, P.countOne, P.count);
  }

  /* ---------- init ---------- */
  function init() {
    native = captureNative();
    readUrl();
    var start = function () {
      load().then(function (res) {
        products = res.products;
        totals = {};
        GROUPS.forEach(function (g) {
          totals[g] = {};
          products.forEach(function (p) {
            (p[g] || []).forEach(function (k) {
              if (!byKey[g][k]) registerValue(g, k); /* tag-driven values coming back from the cache */
              totals[g][k] = (totals[g][k] || 0) + 1;
            });
          });
        });
        /* Tag-driven values that came back from the cache were registered by key; give them their display names back. */
        if (res.names) GROUPS.forEach(function (g) { Object.keys(res.names[g] || {}).forEach(function (k) { if (byKey[g][k]) byKey[g][k].name = res.names[g][k]; }); });
        sortValues();
        var any = GROUPS.some(function (g) { return Object.keys(totals[g]).length > 0; });
        if (!any) { root.hidden = true; return; }
        resolveState();
        GROUPS.forEach(function (g) { state[g] = state[g].filter(function (k) { return totals[g][k]; }); });
        enforceDeps();
        build();
        root.hidden = false;
        apply(false);
      }).catch(function (err) {
        root.hidden = true;
        if (window.console) console.warn('[omega-fb]', err);
      });
    };
    if (urlHasFilters()) start();
    else if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 1500 });
    else setTimeout(start, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.OmegaFilterBar = {
    apply: apply,
    getProfile: function () { return P ? P.id : null; },
    getState: function () { return state; },
    getProducts: function () { return products; },
    getValues: function () { return VALUES; },
    set: function (g, keys) { if (!state[g]) return; state[g] = keys.slice(); enforceDeps(); apply(true); }
  };
})();
